const STYLES = {
  pending: "bg-[#EAE5DE] text-[#6B5D50] border-[#8C7B6B]",
  awaiting_payment: "bg-amber-50 text-amber-800 border-amber-300",
  verified: "bg-emerald-50 text-emerald-800 border-emerald-300",
  shipped: "bg-blue-50 text-blue-800 border-blue-300",
  completed: "bg-[#EFEBE6] text-[#1A1A1A] border-[#DDD7CF]",
  cancelled: "bg-red-50 text-red-800 border-red-300",
};

const LABELS = {
  pending: "Pending Payment",
  awaiting_payment: "Awaiting Payment",
  verified: "Payment Verified",
  shipped: "Shipped",
  completed: "Completed",
  cancelled: "Cancelled",
};

export const StatusBadge = ({ status }) => (
  <span
    data-testid={`status-badge-${status}`}
    className={`inline-flex items-center text-xs tracking-[0.1em] uppercase font-semibold px-3 py-1 rounded-none border ${STYLES[status] || STYLES.pending}`}
  >
    {LABELS[status] || status}
  </span>
);
